import { render, staticRenderFns } from "./ClProducts.vue?vue&type=template&id=ad13189c&scoped=true&"
import script from "./ClProducts.vue?vue&type=script&lang=js&"
export * from "./ClProducts.vue?vue&type=script&lang=js&"
import style0 from "./ClProducts.vue?vue&type=style&index=0&id=ad13189c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad13189c",
  null
  
)

export default component.exports